import { IMessageToolCallResult } from '../../../../../api/types';
import { INTERNAL_SEARCH_TOOL_CALL_NAME } from '../ToolCall/InternalSearchToolCall/consts';

export const SUPPORTED_TOOL_CALL_RESULTS_FOR_DISPLAY = [INTERNAL_SEARCH_TOOL_CALL_NAME];

export const countResults = (
    toolCallsResults: IMessageToolCallResult[],
    supportedTools: string[] = SUPPORTED_TOOL_CALL_RESULTS_FOR_DISPLAY
): number => {
    const map = new Map<string, Set<string>>();

    toolCallsResults.forEach(({ function_name, result }) => {
        if (!supportedTools.includes(function_name)) {
            return;
        }

        if (function_name === INTERNAL_SEARCH_TOOL_CALL_NAME && result?.length) {
            const docIds = result.map((r) => r.doc_id);

            const toolCallResults = map.get(function_name) || new Set();
            const newSet = new Set(Array.from(toolCallResults).concat(docIds));

            map.set(function_name, newSet);
        }
    });

    return Array.from(map.values()).reduce((acc, curr) => acc + curr.size, 0);
};
